import { render, staticRenderFns } from "./EditPlan.vue?vue&type=template&id=81978648&scoped=true&"
import script from "./EditPlan.vue?vue&type=script&lang=js&"
export * from "./EditPlan.vue?vue&type=script&lang=js&"
import style0 from "./EditPlan.vue?vue&type=style&index=0&id=81978648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81978648",
  null
  
)

export default component.exports